/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CallControlsType = {
    AmazonConnect: 'AmazonConnect',
    None: 'None'
} as const;
export type CallControlsType = typeof CallControlsType[keyof typeof CallControlsType];


export function CallControlsTypeFromJSON(json: any): CallControlsType {
    return CallControlsTypeFromJSONTyped(json, false);
}

export function CallControlsTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallControlsType {
    return json as CallControlsType;
}

export function CallControlsTypeToJSON(value?: CallControlsType | null): any {
    return value as any;
}

